import PropTypes from 'prop-types';

const defaultColors = [
    "#970303",
    "#A35454",
    "#786262",
    "#C17E19",
    "#4C74B9",
    "#829671",
    "#67C794",
    "#1DA3D4",
    "#146583",
    "#677FC6",
    "#454E66",
    "#6F55D9",
    "#B862ED",
    "#7300BA",
    "#D63BBA",
    "#B09302",
    "#41A7A9",
    "#571212",
    "#5A758E",
    "#687124",
];

const NameInitialsAvatar = ({ Name }) => {
    // Trim name and apply fallback
    const finalName = (Name || "Participant")?.trim();

    // Split name and get initials
    const splitName = finalName?.split(" ")?.filter(Boolean); // Removes falsy values from the array: undefined, null, "", 0, false.
    const firstInitial = splitName?.[0] ? splitName?.[0]?.[0] : "";
    const lastInitial =
        splitName?.length > 1 ? splitName?.[splitName?.length - 1]?.[0] : "";
    const initials = (firstInitial + lastInitial)?.toUpperCase()?.slice(0, 2);

    // Deterministic pseudo-random index based on string ASCII values
 const stringAsciiPRNG = (value, m) => {
    let hash = 0;
    for (let i = 0; i < value.length; i++) {
        hash = value.charCodeAt(i) + ((hash << 5) - hash); // hash * 31 + charCode
        hash |= 0; // convert to 32bit integer
    }
    return Math.abs(hash) % m;
};

    const getRandomColor = (value, colors = defaultColors) => {
        if (!value) return "transparent";
        const colorIndex = stringAsciiPRNG(value, colors.length);
        return colors[colorIndex] || "black";
    };

    return (
        <div
            className="participant-avatar"
            style={{ backgroundColor: getRandomColor(finalName), }}
        >
            <div className="participant-avatar-span">{initials}</div>
        </div>
    );
};

NameInitialsAvatar.propTypes = {
    Name: PropTypes.string,
};

export default NameInitialsAvatar;
